"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rensouApi = require("@/api/rensou/rensouApi");
var _internal = require("@/components/uploadPicture/internal.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'SpecStockForm',
  data: function data() {
    return {
      // attrType: 'single', // single, multi, sku
      id: this.$route.params.id,
      // 保存原始规格类型，用于编辑模式下恢复
      originalAttrType: null,
      // 防止循环更新的标志
      _isUpdatingFromProps: false,
      _isInitializing: false,
      // 需要传递给后端的数据

      /*
              attr:[], */
      // sku需要请求给后端的数据
      skuCombinations: [],
      // SKU组合数据

      /*
            // 多规格模式专用的attr数据结构
            multipleAttr: [], */

      singleSpecRules: {
        price: [{
          required: true,
          message: '请输入售价',
          trigger: 'blur'
        }],
        stock: [{
          required: true,
          message: '请输入库存',
          trigger: 'blur'
        }]
      },
      // 多规格相关
      rulesList: [],
      // 接口返回的规格列表
      selectedRuleType: '',
      // 当前选择的规格类型ID
      selectedRules: [],
      // 已选择的规格列表
      showAddValueDialog: false,
      currentRuleId: null,
      newRuleValue: '',
      includeWeightRuleName: null,
      // 包含体重和体积的规格值的rule name

      // 规格组合表格数据
      specTableData: [],
      // 规格组合表格数据
      defaultSelectedSpec: null,
      // 默认选中的规格组合
      selectedSkuIndex: 0,
      // 当前选中的SKU索引

      // 用于存储初始化和新增的规格值
      editableRules: [],
      // 可编辑的规格列表
      originalRules: [],
      // 原始规格列表（用于展示）

      // 批量设置数据表单
      bulkDataForm: {
        specName: '批量设置',
        // 规格名称
        otPrice: 0,
        price: 0,
        costPrice: '0',
        stock: '0',
        status: 1,
        // 上下架状态，1表示上架，0表示下架
        stockWarning: '0',
        minQuantity: '1',
        maxQuantity: 999,
        weight: 0,
        // 重量（kg）
        barCode: '',
        // 商品条码
        image: '' // 图片URL
      }
    };
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    attrType: {
      type: String,
      default: function _default() {
        return {};
      }
    },
    // single, multi, sku
    singleSpecForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    multipleAttr: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    attr: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    attrValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // SKU模式下的规格组合数据

    isWmTg: {
      type: [Number, String],
      default: undefined
    },
    appointmentTimeFlag: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    isEditMode: function isEditMode() {
      return !!this.$route.params.id && !(this.$route.query && this.$route.query.copy);
    },
    hideSpecTypeSelector: function hideSpecTypeSelector() {
      return this.isWmTg === 2 || this.isWmTg === 3;
    },
    hideDateModeStockFields: function hideDateModeStockFields() {
      return this.isWmTg === 3 || this.isWmTg === 2 && Number(this.appointmentTimeFlag) === 1;
    },
    showBarCodeField: function showBarCodeField() {
      return this.isWmTg !== 2 && this.isWmTg !== 3;
    },
    dynamicSingleSpecRules: function dynamicSingleSpecRules() {
      var rules = {
        price: [{
          required: true,
          message: '请输入售价',
          trigger: 'blur'
        }],
        minQuantity: [{
          required: true,
          message: '请输入起购数量',
          trigger: ['blur', 'change']
        }, {
          validator: function validator(rule, value, callback) {
            var num = parseFloat(value);
            if (Number.isNaN(num) || num < 1) {
              callback(new Error('起购数量不能小于1'));
              return;
            }
            callback();
          },
          trigger: ['blur', 'change']
        }]
      };
      if (!this.hideDateModeStockFields) {
        rules.stock = [{
          required: true,
          message: '请输入库存',
          trigger: 'blur'
        }];
      }
      return rules;
    }
  },
  mounted: function mounted() {
    //自动生成SKU
    console.log('当前编辑数据的id是', this.id);
    this.getRulesList();
    // 如果父组件传递了multipleAttr数据，初始化editableRules
    this.initializeFromProps();
  },
  methods: {
    // 获取商品的attrValue数据（编辑模式专用）
    getProductAttrValue: function () {
      var _getProductAttrValue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var _this2 = this;
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!this._isInitializing) {
                _context.n = 1;
                break;
              }
              console.log('正在初始化中，跳过重复调用');
              return _context.a(2);
            case 1:
              _context.p = 1;
              this._isInitializing = true;
              _context.n = 2;
              return (0, _rensouApi.getMerchantProductInfo)(id);
            case 2:
              res = _context.v;
              if (res && res.attrValue) {
                // 直接处理attrValue数据
                if (Array.isArray(res.attrValue) && res.attrValue.length > 0) {
                  this.initializeSkuCombinationsFromAttrValue(res.attrValue);
                  // 等待处理完成后验证
                  setTimeout(function () {
                    _this2._isInitializing = false;
                  }, 200);
                } else {
                  this._isInitializing = false;
                }
              } else {
                this._isInitializing = false;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this._isInitializing = false;
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function getProductAttrValue(_x) {
        return _getProductAttrValue.apply(this, arguments);
      }
      return getProductAttrValue;
    }(),
    // 获取规格列表
    getRulesList: function () {
      var _getRulesList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _rensouApi.getRules)();
            case 1:
              res = _context2.v;
              if (res && Array.isArray(res)) {
                // 对数据进行清洗，处理嵌套的ruleValue字段（接口返回的字段名）
                this.rulesList = res.map(function (rule) {
                  var processedRuleValue = [];

                  // 检查接口返回的字段名（可能是ruleValue或attrValues）
                  var sourceField = rule.ruleValue || rule.attrValues;

                  // 如果字段值是字符串，尝试解析为JSON
                  if (typeof sourceField === 'string') {
                    try {
                      var parsedValue = JSON.parse(sourceField);
                      // 处理嵌套结构：每个value包含detail数组
                      if (Array.isArray(parsedValue)) {
                        processedRuleValue = parsedValue;
                      }
                    } catch (e) {
                      console.warn('解析规格值失败:', sourceField);
                      processedRuleValue = [];
                    }
                  } else if (Array.isArray(sourceField)) {
                    processedRuleValue = sourceField;
                  }
                  return _objectSpread(_objectSpread({}, rule), {}, {
                    attrValues: processedRuleValue // 统一使用attrValues字段名，这里是规格分类数组，如[{value:"尺寸", detail:["6寸","8寸"]}, {value:"夹心", detail:["芒果","布丁"]}]
                  });
                });
                console.log('清洗后的数据:', this.rulesList);
              }
              console.log(this.rulesList);
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error('获取规格列表失败:', _t2);
              this.$message.error('获取规格列表失败');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getRulesList() {
        return _getRulesList.apply(this, arguments);
      }
      return getRulesList;
    }(),
    // 确认添加规格
    confirmAddRule: function confirmAddRule() {
      var _this3 = this;
      if (!this.selectedRuleType) {
        this.$message.warning('请选择规格类型');
        return;
      }

      // 从规格列表中找到选中的规格
      var selectedRule = this.rulesList.find(function (rule) {
        return rule.id === _this3.selectedRuleType;
      });
      if (selectedRule) {
        // 检查是否已经添加过该规格
        var isDuplicate = this.selectedRules.some(function (existingRule) {
          // 检查是否有相同的规格名称或父级规格名称
          if (existingRule.parentRuleName === selectedRule.ruleName || existingRule.ruleName === selectedRule.ruleName || selectedRule.attrValues && selectedRule.attrValues.some(function (category) {
            return existingRule.ruleName === category.value || existingRule.attrName === category.value;
          })) {
            return true;
          }
          return false;
        });
        if (isDuplicate) {
          this.$message.warning("\u89C4\u683C\"".concat(selectedRule.ruleName, "\"\u5DF2\u5B58\u5728\uFF0C\u4E0D\u80FD\u91CD\u590D\u6DFB\u52A0"));
          return;
        }

        // 处理嵌套结构，将每个规格分类展开为独立的规格
        var expandedRules = [];
        var editableRulesArray = [];
        if (selectedRule.attrValues && Array.isArray(selectedRule.attrValues)) {
          selectedRule.attrValues.forEach(function (category, index) {
            if (category.value && Array.isArray(category.detail)) {
              // 生成唯一ID，使用组合索引避免冲突
              var uniqueId = selectedRule.id * 1000 + index;

              // 为每个规格分类创建独立的规格对象（只读版本）
              var readOnlyRule = {
                id: uniqueId,
                // 生成唯一ID
                ruleName: category.value,
                // 规格名称，如"尺寸"、"夹心"
                attrName: category.value,
                attrCode: index,
                // 添加 attrCode 字段为当前数据的索引值
                attrValues: category.detail.map(function (detailValue, valueIndex) {
                  return {
                    valueName: detailValue,
                    // 规格值，如"6寸"、"芒果"
                    price: '0',
                    otPrice: '0',
                    costPrice: '',
                    status: 1,
                    valueCode: valueIndex,
                    // 添加valueCode字段
                    sort: 1,
                    // 固定为1
                    checked: valueIndex === 0 ? 1 : 0 // 第一个默认选中，其他为未选中
                  };
                }),
                valueCode: 0,
                parentRuleName: selectedRule.ruleName // 记录父级规格名称，如"蛋糕"
              };

              // 为每个规格分类创建可编辑版本
              var editableRule = {
                id: uniqueId,
                // 使用相同的唯一ID
                ruleName: category.value,
                // 规格名称，如"尺寸"、"夹心"
                attrName: category.value,
                attrCode: index,
                // 添加 attrCode 字段为当前数据的索引值
                attrValues: category.detail.map(function (detailValue, valueIndex) {
                  return {
                    valueName: detailValue,
                    // 规格值，如"6寸"、"芒果"
                    price: '0',
                    otPrice: '0',
                    costPrice: '',
                    status: 1,
                    sort: 1,
                    // 固定为1
                    checked: valueIndex === 0 ? 1 : 0,
                    // 第一个默认选中，其他为未选中
                    valueCode: valueIndex // 当前数据的索引值
                  };
                }),
                valueCode: 0,
                parentRuleName: selectedRule.ruleName // 记录父级规格名称，如"蛋糕"
              };
              expandedRules.push(readOnlyRule);
              editableRulesArray.push(editableRule);
            }
          });
        }
        if (expandedRules.length > 0) {
          // 替换当前规格列表（只读版本用于上方展示）
          this.selectedRules = expandedRules;
          // 可编辑版本用于表格操作
          this.editableRules = editableRulesArray;
          // 保存原始规则用于参考
          this.originalRules = JSON.parse(JSON.stringify(expandedRules));

          // 更新SKU组合（如果在SKU模式下）
          if (this.attrType === 'sku') {
            this.updateSkuCombinations();
          }
          this.$message.success("\u5DF2\u9009\u62E9\u89C4\u683C: ".concat(selectedRule.ruleName, "\uFF0C\u5305\u542B ").concat(expandedRules.length, " \u4E2A\u5B50\u89C4\u683C"));
        } else {
          this.$message.warning('选择的规格没有可用的子规格');
        }

        // 保留已选择的规格值，不清空下拉框
        // this.selectedRuleType = '';
      }
    },
    // 显示添加规格对话框
    showAddSpecDialog: function showAddSpecDialog() {
      var _this4 = this;
      // 使用Element UI的Dialog组件
      this.$confirm('', '添加规格', {
        customClass: 'add-spec-dialog',
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        beforeClose: function beforeClose(action, instance, done) {
          if (action === 'confirm') {
            // 获取表单数据
            var specName = document.querySelector('.add-spec-dialog .spec-name-input').value;
            var specValues = document.querySelector('.add-spec-dialog .spec-values-input').value;
            if (!specName || !specName.trim()) {
              _this4.$message.warning('请输入规格名称');
              return;
            }
            if (!specValues || !specValues.trim()) {
              _this4.$message.warning('请输入规格值，多个值用逗号分隔');
              return;
            }

            // 处理规格值，按逗号分隔
            var valueArray = specValues.split(',').map(function (v) {
              return v.trim();
            }).filter(function (v) {
              return v;
            });
            if (valueArray.length === 0) {
              _this4.$message.warning('请输入有效的规格值');
              return;
            }

            // 检查规格值是否有重复
            var uniqueValues = _toConsumableArray(new Set(valueArray));
            if (uniqueValues.length !== valueArray.length) {
              _this4.$message.warning('输入的规格值中存在重复项，请检查');
              return;
            }

            // 检查规格值是否与已有规格名称冲突
            var conflictWithSpecName = _this4.selectedRules.some(function (rule) {
              return valueArray.some(function (value) {
                return rule.ruleName === value || rule.attrName === value;
              });
            });
            if (conflictWithSpecName) {
              _this4.$confirm('输入的规格值与已有规格名称冲突，确定要添加吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(function () {
                // 创建新规格对象
                _this4.addNewSpecWithValues(specName.trim(), valueArray);
                done();
              }).catch(function () {});
              return;
            }

            // 创建新规格对象
            _this4.addNewSpecWithValues(specName.trim(), valueArray);
            done();
          } else {
            done();
          }
        },
        message: "\n          <div class=\"add-spec-form\">\n            <div class=\"form-item\">\n              <label>\u89C4\u683C\u540D\u79F0\uFF1A</label>\n              <input class=\"el-input__inner spec-name-input\" placeholder=\"\u8BF7\u8F93\u5165\u89C4\u683C\u540D\u79F0\uFF0C\u5982\uFF1A\u5C3A\u5BF8\u3001\u989C\u8272\" autocomplete=\"off\" />\n            </div>\n            <div class=\"form-item\">\n              <label>\u89C4\u683C\u503C\uFF1A</label>\n              <input class=\"el-input__inner spec-values-input\" placeholder=\"\u8BF7\u8F93\u5165\u89C4\u683C\u503C\uFF0C\u591A\u4E2A\u503C\u7528\u9017\u53F7\u5206\u9694\" autocomplete=\"off\" />\n            </div>\n            <div class=\"form-tip\">\u4F8B\u5982\uFF1A\u5C3A\u5BF8 - 6\u5BF8,8\u5BF8,10\u5BF8</div>\n            <style>\n              .add-spec-form .form-item {\n                margin-bottom: 15px;\n              }\n              .add-spec-form label {\n                display: block;\n                margin-bottom: 5px;\n                font-weight: bold;\n              }\n              .add-spec-form .form-tip {\n                color: #909399;\n                font-size: 12px;\n                margin-top: 5px;\n              }\n              .add-spec-form .el-input__inner {\n                width: 100%;\n                padding: 0 15px;\n                height: 32px;\n                line-height: 32px;\n                border: 1px solid #dcdfe6;\n                border-radius: 4px;\n              }\n            </style>\n          </div>\n        "
      }).then(function () {
        // 对话框打开后，延时清空输入框的值
        setTimeout(function () {
          var nameInput = document.querySelector('.add-spec-dialog .spec-name-input');
          var valuesInput = document.querySelector('.add-spec-dialog .spec-values-input');
          if (nameInput) nameInput.value = '';
          if (valuesInput) valuesInput.value = '';
        }, 100);
      }).catch(function () {});
    },
    // 添加新规格和规格值
    addNewSpecWithValues: function addNewSpecWithValues(specName, valueArray) {
      // 检查是否已经添加过该规格名称
      var isDuplicate = this.selectedRules.some(function (existingRule) {
        // 检查规格名称是否相同
        if (existingRule.ruleName === specName || existingRule.attrName === specName || existingRule.parentRuleName === specName) {
          return true;
        }

        // 检查是否与已有规格的子规格名称相同
        if (existingRule.attrValues && Array.isArray(existingRule.attrValues)) {
          var _iterator = _createForOfIteratorHelper(existingRule.attrValues),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var value = _step.value;
              if (value.valueName === specName) {
                return true;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        return false;
      });
      if (isDuplicate) {
        this.$message.warning("\u89C4\u683C\"".concat(specName, "\"\u5DF2\u5B58\u5728\uFF0C\u4E0D\u80FD\u91CD\u590D\u6DFB\u52A0"));
        return;
      }

      // 生成唯一ID，使用负数避免与后端ID冲突
      var newId = -(Date.now() % 1000000); // 使用负数的时间戳后6位

      // 创建规格对象（只读版本）
      var readOnlyRule = {
        id: newId,
        ruleName: specName,
        attrName: specName,
        attrValues: valueArray.map(function (value) {
          return {
            valueName: value,
            price: '0',
            otPrice: '0',
            costPrice: '',
            status: 1
          };
        }),
        valueCode: 0,
        isCustom: true // 标记为自定义规格
      };

      // 创建可编辑版本
      var editableRule = {
        id: newId,
        ruleName: specName,
        attrName: specName,
        attrCode: this.editableRules.length,
        // 添加 attrCode 字段为当前规格的索引值
        attrValues: valueArray.map(function (value, valueIndex) {
          return {
            valueName: value,
            price: '0',
            otPrice: '0',
            costPrice: '',
            status: 1,
            sort: 1,
            // 固定为1
            checked: valueIndex === 0 ? 1 : 0,
            // 第一个默认选中，其他为未选中
            valueCode: valueIndex // 当前数据的索引值
          };
        }),
        valueCode: 0,
        isCustom: true
      };

      // 创建原始版本（用于参考）
      var originalRule = JSON.parse(JSON.stringify(readOnlyRule));

      // 添加到数据结构
      this.selectedRules = [].concat(_toConsumableArray(this.selectedRules), [readOnlyRule]);
      this.editableRules = [].concat(_toConsumableArray(this.editableRules), [editableRule]);
      this.originalRules = [].concat(_toConsumableArray(this.originalRules), [originalRule]);

      // 更新SKU组合（如果在SKU模式下）
      if (this.attrType === 'sku') {
        this.updateSkuCombinations();
      }
      this.$message.success("\u6210\u529F\u6DFB\u52A0\u89C4\u683C: ".concat(specName));
    },
    // 添加新规格
    addNewRule: function addNewRule() {
      this.showAddSpecDialog();
    },
    // 添加规格值
    addRuleValue: function addRuleValue(ruleIdentifier) {
      var _this5 = this;
      console.log('当前编辑数据的id是', this.id);
      this.$prompt('请输入规格值', '添加规格值', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function (_ref) {
        var value = _ref.value;
        if (value && value.trim()) {
          // 在可编辑的规则中查找 - 优先使用attrCode，后备使用id
          var editableRule = _this5.editableRules.find(function (r) {
            return r.attrCode !== undefined ? r.attrCode === ruleIdentifier : r.id === ruleIdentifier;
          });

          // 同时在selectedRules中查找对应的规则
          var selectedRule = _this5.selectedRules.find(function (r) {
            return r.attrCode !== undefined ? r.attrCode === ruleIdentifier : r.id === ruleIdentifier;
          });
          if (editableRule) {
            // 检查当前规格中是否已存在相同的值
            var existingValue = editableRule.attrValues.find(function (v) {
              return v.valueName === value.trim();
            });
            if (existingValue) {
              _this5.$message.warning("\u89C4\u683C\u503C\"".concat(value.trim(), "\"\u5DF2\u5B58\u5728\u4E8E\u5F53\u524D\u89C4\u683C\u4E2D"));
              return;
            }

            // 检查其他规格中是否有相同的规格值，如果有则给出警告但允许添加
            var existsInOtherRules = _this5.editableRules.some(function (rule) {
              var currentRuleIdentifier = rule.attrCode !== undefined ? rule.attrCode : rule.id;
              if (currentRuleIdentifier !== ruleIdentifier) {
                return rule.attrValues.some(function (v) {
                  return v.valueName === value.trim();
                });
              }
              return false;
            });
            if (existsInOtherRules) {
              _this5.$confirm("\u89C4\u683C\u503C\"".concat(value.trim(), "\"\u5DF2\u5B58\u5728\u4E8E\u5176\u4ED6\u89C4\u683C\u4E2D\uFF0C\u786E\u5B9A\u8981\u6DFB\u52A0\u5417\uFF1F"), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(function () {
                // 用户确认添加，继续执行添加逻辑
                _this5.addRuleValueConfirmed(editableRule, selectedRule, value.trim());
              }).catch(function () {
                // 用户取消添加
              });
              return;
            }

            // 执行添加规格值的逻辑
            _this5.addRuleValueConfirmed(editableRule, selectedRule, value.trim());
          }
        }
      });
    },
    // 添加规格值的确认方法
    addRuleValueConfirmed: function addRuleValueConfirmed(editableRule, selectedRule, value) {
      // 获取新规格值的索引（当前长度就是新索引）
      var newValueIndex = editableRule.attrValues.length;

      // 添加规格值并包含价格等信息
      var newValue = {
        valueName: value,
        price: '0',
        // 默认价格为0
        otPrice: '0',
        // 默认原价为0
        costPrice: '',
        status: 1,
        // 默认启用
        sort: 1,
        // 固定为1
        checked: 0,
        // 新添加的默认为未选中
        valueCode: newValueIndex // 当前数据的索引值
      };

      // 添加到可编辑规则中
      editableRule.attrValues.push(newValue);

      // 同步添加到selectedRules中
      if (selectedRule) {
        var selectedRuleValue = {
          valueName: value,
          price: '0',
          otPrice: '0',
          costPrice: '',
          status: 1,
          valueCode: newValueIndex // 确保selectedRule中也有正确的valueCode
        };
        selectedRule.attrValues.push(selectedRuleValue);
      }

      // 如果是第一个规格值，设为默认选中
      if (editableRule.attrValues.length === 1) {
        editableRule.valueCode = 0;
        if (selectedRule) {
          selectedRule.valueCode = 0;
        }
      }

      // 更新SKU组合（如果在SKU模式下）
      if (this.attrType === 'sku') {
        this.updateSkuCombinations();
      }
      this.$message.success('添加规格值成功');
    },
    // 从父组件props初始化数据
    initializeFromProps: function initializeFromProps() {
      // SKU模式：初始化attr和attrValue数据
      if (this.attrType === 'sku') {
        // 初始化规格数据
        var attrData = null;
        if (Array.isArray(this.attr) && this.attr.length > 0) {
          attrData = this.attr;
        } else if (this.attr && _typeof(this.attr) === 'object' && Object.keys(this.attr).length > 0) {
          // 处理对象格式
          if (this.attr.attr && Array.isArray(this.attr.attr)) {
            attrData = this.attr.attr;
          } else {
            attrData = Object.values(this.attr);
          }
        }
        if (attrData && attrData.length > 0) {
          this.initializeSkuFromAttr(attrData);
        }

        // 初始化SKU组合数据
        var attrValueData = null;
        if (Array.isArray(this.attrValue) && this.attrValue.length > 0) {
          attrValueData = this.attrValue;
        } else if (this.attrValue && _typeof(this.attrValue) === 'object' && Object.keys(this.attrValue).length > 0) {
          // 处理对象格式
          if (this.attrValue.attrValue && Array.isArray(this.attrValue.attrValue)) {
            attrValueData = this.attrValue.attrValue;
          } else {
            attrValueData = Object.values(this.attrValue);
          }
        }
        if (attrValueData && attrValueData.length > 0) {
          this.initializeSkuCombinationsFromAttrValue(attrValueData);
        }
      }
      // 多规格模式：初始化multipleAttr数据
      else if (this.multipleAttr && this.multipleAttr.attrGroups && Array.isArray(this.multipleAttr.attrGroups)) {
        // 深拷贝并规范化布尔值为数字
        this.editableRules = this.multipleAttr.attrGroups.map(function (rule) {
          var normalizedRule = _objectSpread({}, rule);

          // 处理attrValues中的disabled和checked值
          if (normalizedRule.attrValues && Array.isArray(normalizedRule.attrValues)) {
            normalizedRule.attrValues = normalizedRule.attrValues.map(function (value, index) {
              var normalizedValue = _objectSpread({}, value);

              // 将disabled/status的布尔值转换为数字，优先使用status字段
              if (normalizedValue.status !== undefined) {
                normalizedValue.status = normalizedValue.status === true ? 1 : normalizedValue.status === false ? 0 : normalizedValue.status;
              } else if (normalizedValue.disabled !== undefined) {
                // 向后兼容：将disabled转换为status
                normalizedValue.status = normalizedValue.disabled === true ? 1 : normalizedValue.disabled === false ? 0 : normalizedValue.disabled;
                delete normalizedValue.disabled; // 删除旧的disabled字段
              } else {
                normalizedValue.status = 1; // 默认开启
              }

              // 确保valueCode存在
              if (normalizedValue.valueCode === undefined) {
                normalizedValue.valueCode = index;
              }
              normalizedValue.costPrice = normalizedValue.costPrice !== undefined && normalizedValue.costPrice !== null ? String(normalizedValue.costPrice) : '';
              return normalizedValue;
            });

            // 确保rule有valueCode，如果没有则设为第一个启用的规格值索引
            if (normalizedRule.valueCode === undefined || normalizedRule.valueCode === null) {
              // 查找第一个启用的规格值索引
              var firstEnabledIndex = normalizedRule.attrValues.findIndex(function (v) {
                return v.status === 1;
              });
              normalizedRule.valueCode = firstEnabledIndex >= 0 ? firstEnabledIndex : 0;
            }
          }
          return normalizedRule;
        });

        // 同时初始化selectedRules，确保与editableRules保持同步
        this.selectedRules = this.editableRules.map(function (rule) {
          return _objectSpread(_objectSpread({}, rule), {}, {
            id: rule.id,
            attrCode: rule.attrCode,
            // 确保attrCode也被复制
            attrValues: rule.attrValues.map(function (value) {
              return {
                valueName: value.valueName,
                price: value.price || '0',
                otPrice: value.otPrice || '0',
                costPrice: value.costPrice !== undefined && value.costPrice !== null ? String(value.costPrice) : '',
                status: value.status,
                valueCode: value.valueCode // 确保valueCode也被复制
              };
            })
          });
        });
      }
    },
    // 初始化SKU规格数据（从attr属性）
    initializeSkuFromAttr: function initializeSkuFromAttr(attrData) {
      var _this6 = this;
      try {
        // 清空现有数据
        this.selectedRules = [];
        this.editableRules = [];
        this.originalRules = [];

        // 根据attr数据重建规格
        attrData.forEach(function (attr, attrIndex) {
          if (attr.attrName && attr.attrValues) {
            // 解析规格值字符串
            var attrValues = attr.attrValues.split(',').filter(function (val) {
              return val.trim();
            });
            if (attrValues.length > 0) {
              // 生成唯一ID
              var uniqueId = attr.id || Date.now() + attrIndex;

              // 创建规格对象（只读版本）
              var readOnlyRule = {
                id: uniqueId,
                ruleName: attr.attrName,
                attrName: attr.attrName,
                attrCode: attr.attrCode !== undefined ? attr.attrCode : attrIndex,
                attrValues: attrValues.map(function (valueName, valueIndex) {
                  return {
                    valueName: valueName.trim(),
                    price: '0',
                    otPrice: '0',
                    costPrice: '',
                    disabled: 1,
                    valueCode: valueIndex,
                    sort: 1,
                    checked: valueIndex === 0 ? 1 : 0
                  };
                }),
                valueCode: 0,
                isFromEdit: true // 标记为编辑模式数据
              };

              // 创建可编辑版本
              var editableRule = _objectSpread(_objectSpread({}, readOnlyRule), {}, {
                attrValues: readOnlyRule.attrValues.map(function (value) {
                  return _objectSpread({}, value);
                })
              });

              // 创建原始版本
              var originalRule = JSON.parse(JSON.stringify(readOnlyRule));

              // 添加到数据结构
              _this6.selectedRules.push(readOnlyRule);
              _this6.editableRules.push(editableRule);
              _this6.originalRules.push(originalRule);
            }
          }
        });

        // 如果还没有attrValue数据，则更新SKU组合
        if (this.attrType === 'sku' && (!this.attrValue || this.attrValue.length === 0)) {
          this.updateSkuCombinations();
        }
      } catch (error) {
        console.error('初始化SKU规格数据时发生错误:', error);
      }
    },
    // 初始化SKU组合数据（从attrValue属性）
    initializeSkuCombinationsFromAttrValue: function initializeSkuCombinationsFromAttrValue(attrValueData) {
      var _this7 = this;
      try {
        console.log('=== 开始初始化SKU组合数据 ===');
        console.log('接收到的attrValueData:', attrValueData);
        console.log('原始数据类型:', Array.isArray(attrValueData) ? 'Array' : _typeof(attrValueData));
        console.log('原始数据长度:', attrValueData === null || attrValueData === void 0 ? void 0 : attrValueData.length);

        // 数据转换处理：确保status和checked是数字格式
        var processedData = attrValueData.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            status: item.status === true ? 1 : item.status === false ? 0 : item.status,
            checked: item.checked === true ? 1 : item.checked === false ? 0 : item.checked
          });
        });
        console.log('处理后的数据:', processedData);

        // 强制清空并重新赋值
        this.$set(this, 'skuCombinations', []);

        // 延迟赋值，确保响应式更新
        setTimeout(function () {
          _this7.$set(_this7, 'skuCombinations', processedData);
          console.log('Vue.set设置后的skuCombinations:', _this7.skuCombinations);
          console.log('skuCombinations长度:', _this7.skuCombinations.length);

          // 设置选中的SKU索引
          var checkedIndex = _this7.skuCombinations.findIndex(function (item) {
            return item.checked === 1 || item.checked === true;
          });
          _this7.selectedSkuIndex = checkedIndex >= 0 ? checkedIndex : 0;
          console.log('设置选中的SKU索引:', _this7.selectedSkuIndex);
          if (_this7.skuCombinations.length > 0) {
            console.log('验证 - 第一条数据:', _this7.skuCombinations[0]);
          }
        }, 100);
      } catch (error) {
        console.error('初始化SKU组合数据时发生错误:', error);
      }
    },
    // 获取规格值表格数据
    getSpecValueTableData: function getSpecValueTableData(rule) {
      return rule.attrValues || [];
    },
    // 处理默认规格值变更
    handleDefaultValueChange: function handleDefaultValueChange(rule, index) {
      rule.valueCode = index;

      // 更新 checked 字段：将所有规格值设为未选中，只有当前选中的设为选中
      if (rule.attrValues && Array.isArray(rule.attrValues)) {
        rule.attrValues.forEach(function (attrValue, ruleIndex) {
          // 确保使用数字类型的值，不使用布尔值
          attrValue.checked = ruleIndex === index ? 1 : 0;
        });
      }

      // 多规格模式下，更新multipleAttr结构
      if (this.attrType === 'multi') {
        this.updateMultipleAttrStructure();
      }
    },
    // 处理价格变化
    handlePriceChange: function handlePriceChange() {
      var _this8 = this;
      // 多规格模式下，价格变化时更新multipleAttr结构
      if (this.attrType === 'multi') {
        // 使用 nextTick 确保数据已更新
        this.$nextTick(function () {
          _this8.updateMultipleAttrStructure();
        });
      }
    },
    // 处理状态变化
    handleStatusChange: function handleStatusChange(rule, index, newStatus) {
      // 如果只有一个规格值，不允许设置为关闭状态
      if (rule.attrValues.length === 1 && newStatus === 0) {
        this.$message.warning('只有一个规格值时不能设置为关闭状态');
        // 恢复状态为开启
        rule.attrValues[index].status = 1;
        return;
      }

      // 检查是否会导致所有规格值都为关闭状态
      if (newStatus === 0) {
        // 计算开启状态的规格值数量
        var enabledCount = rule.attrValues.reduce(function (count, item, idx) {
          // 当前正在修改的项不计算在内
          if (idx === index) return count;
          // 只计算开启状态的项
          return item.status === 1 ? count + 1 : count;
        }, 0);

        // 如果没有其他开启状态的规格值，则不允许关闭
        if (enabledCount === 0) {
          this.$message.warning('至少需要保持一个规格值为开启状态');
          // 恢复状态为开启
          rule.attrValues[index].status = 1;
          return;
        }
      }

      // 如果关闭的是当前选中的规格值，需要自动切换默认选中项
      if (newStatus === 0 && rule.valueCode === index) {
        // 查找下一个可用（开启状态）的规格值
        var nextAvailableIndex = -1;

        // 先尝试找后面的开启状态的规格值
        for (var i = 0; i < rule.attrValues.length; i++) {
          if (i !== index && rule.attrValues[i].status === 1) {
            nextAvailableIndex = i;
            break;
          }
        }

        // 如果没找到，则设置为第一个开启状态的规格值
        if (nextAvailableIndex === -1) {
          this.$message.warning('没有其他开启状态的规格值可选，无法设置为默认值');
          return;
        }

        // 设置新的默认选中项
        this.handleDefaultValueChange(rule, nextAvailableIndex);
      }

      // 多规格模式下，状态变化时更新multipleAttr结构
      if (this.attrType === 'multi') {
        this.updateMultipleAttrStructure();
      }
    },
    // 移除规格值
    removeRuleValue: function removeRuleValue(ruleIdentifier, valueIndex) {
      var _this9 = this;
      if (this.isEditMode) {
        this.$message.warning('编辑模式下不能删除规格值');
        return;
      }
      // 在可编辑的规则中查找 - 优先使用attrCode，后备使用id
      var editableRule = this.editableRules.find(function (r) {
        return r.attrCode !== undefined ? r.attrCode === ruleIdentifier : r.id === ruleIdentifier;
      });
      // 同时在selectedRules中查找对应的规则
      var selectedRule = this.selectedRules.find(function (r) {
        return r.attrCode !== undefined ? r.attrCode === ruleIdentifier : r.id === ruleIdentifier;
      });
      if (editableRule && editableRule.attrValues[valueIndex]) {
        // 获取要删除的规格值
        var valueToRemove = editableRule.attrValues[valueIndex].valueName;

        // 检查是否是原始规格值
        var originalRule = this.originalRules.find(function (r) {
          return r.attrCode !== undefined ? r.attrCode === ruleIdentifier : r.id === ruleIdentifier;
        });
        var isOriginalValue = originalRule && originalRule.attrValues.length > valueIndex && originalRule.attrValues[valueIndex].valueName === editableRule.attrValues[valueIndex].valueName;
        var removeValueAndUpdate = function removeValueAndUpdate() {
          // 从editableRules中删除规格值
          editableRule.attrValues.splice(valueIndex, 1);

          // 同步更新selectedRules中的规格值
          if (selectedRule && selectedRule.attrValues && selectedRule.attrValues.length > valueIndex) {
            // 直接使用相同的索引删除selectedRules中的规格值
            selectedRule.attrValues.splice(valueIndex, 1);
          }

          // 重新分配所有规格值的 valueCode 和 checked 字段
          editableRule.attrValues.forEach(function (attrValues, newIndex) {
            attrValues.valueCode = newIndex;
            attrValues.checked = 0; // 先全部设为未选中
          });

          // 如果删除的是默认选中项，重新设置默认选中
          if (editableRule.valueCode === valueIndex) {
            editableRule.valueCode = editableRule.attrValues.length > 0 ? 0 : 0;
            if (selectedRule) {
              selectedRule.valueCode = editableRule.valueCode;
            }
          } else if (editableRule.valueCode > valueIndex) {
            // 如果删除的项在默认选中项之前，需要调整默认选中项的索引
            editableRule.valueCode--;
            if (selectedRule) {
              selectedRule.valueCode = editableRule.valueCode;
            }
          }

          // 设置当前选中项的 checked 为 1
          if (editableRule.attrValues.length > 0 && editableRule.attrValues[editableRule.valueCode]) {
            editableRule.attrValues[editableRule.valueCode].checked = 1;
          }

          // 更新SKU组合（如果在SKU模式下）
          if (_this9.attrType === 'sku') {
            _this9.updateSkuCombinations();
          } else if (_this9.attrType === 'multi') {
            // 多规格模式下，更新multipleAttr结构
            _this9.updateMultipleAttrStructure();
          }
          _this9.$message.success('删除成功');
        };

        // 如果是原始规格值，提示确认
        if (isOriginalValue) {
          this.$confirm('确定要删除原始规格值吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            removeValueAndUpdate();
          }).catch(function () {});
        } else {
          // 如果不是原始规格值，直接删除
          removeValueAndUpdate();
        }
      }
    },
    // 删除整个规格
    removeRule: function removeRule(ruleIdentifier) {
      var _this0 = this;
      if (this.id) {
        this.$message.warning('编辑模式下不能删除规格');
        return;
      }
      this.$confirm('确定要删除这个规格吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 从selectedRules中删除
        var selectedIndex = _this0.selectedRules.findIndex(function (rule) {
          return rule.attrCode !== undefined ? rule.attrCode === ruleIdentifier : rule.id === ruleIdentifier;
        });
        if (selectedIndex > -1) {
          _this0.selectedRules.splice(selectedIndex, 1);
        }

        // 从editableRules中删除
        var editableIndex = _this0.editableRules.findIndex(function (rule) {
          return rule.attrCode !== undefined ? rule.attrCode === ruleIdentifier : rule.id === ruleIdentifier;
        });
        if (editableIndex > -1) {
          _this0.editableRules.splice(editableIndex, 1);
        }

        // 从originalRules中删除
        var originalIndex = _this0.originalRules.findIndex(function (rule) {
          return rule.attrCode !== undefined ? rule.attrCode === ruleIdentifier : rule.id === ruleIdentifier;
        });
        if (originalIndex > -1) {
          _this0.originalRules.splice(originalIndex, 1);
        }

        // 更新SKU组合（如果在SKU模式下）
        if (_this0.attrType === 'sku') {
          _this0.updateSkuCombinations();
        }
        _this0.$message.success('删除成功');
      }).catch(function () {
        // 用户取消删除
      });
    },
    // 获取标签类型（用于不同颜色显示）
    getTagType: function getTagType(index) {
      var types = ['', 'success', 'info', 'warning', 'danger'];
      return types[index % types.length];
    },
    // 规格类型切换
    handleattrTypeChange: function handleattrTypeChange(type) {
      this.attrType = type;
      console.log('切换规格类型:', type);
      if (type !== 'multi') {
        // 切换到其他模式时清空选择的规格
        this.selectedRules = [];
        this.selectedRuleType = '';
        this.editableRules = [];
        this.originalRules = [];
        this.skuCombinations = [];
      }
    },
    // 监听规格变化，自动更新SKU组合
    updateSkuCombinations: function updateSkuCombinations() {
      if (this.attrType === 'sku') {
        this.generateSkuCombinations();

        // 更新attr数据结构
        this.updateAttrStructure();
      }
    },
    // 更新attr数据结构（仅在SKU模式下）
    updateAttrStructure: function updateAttrStructure() {
      if (this.attrType === 'sku') {
        if (this.selectedRules.length > 0) {
          // 根据selectedRules动态构建attr数组
          this.attr = this.selectedRules.map(function (rule) {
            // 收集该规格下的所有规格值
            var attrValues = rule.attrValues && Array.isArray(rule.attrValues) ? rule.attrValues.map(function (valueItem) {
              return valueItem.valueName;
            }).join(',') : '';
            return {
              attrName: rule.attrName || rule.ruleName,
              attrValues: attrValues,
              id: rule.id,
              attrCode: rule.attrCode // 添加attrCode字段
            };
          });
        } else {
          // 当没有选择规格时，重置为初始状态
          this.attr = [{
            "attrName": "",
            "attrValues": "",
            "id": 0
          }];
        }
      }
    },
    // 获取默认规格显示文本（顿号拼接）
    getDefaultSpecsDisplay: function getDefaultSpecsDisplay() {
      if (!this.multipleAttr || this.multipleAttr.length === 0) {
        return '暂无规格';
      }

      // 使用顿号拼接规格名和值
      return this.multipleAttr.map(function (item) {
        return "".concat(item.attrName, "\uFF1A").concat(item.attrValue);
      }).join('、');
    },
    // 获取总价显示（价格相加）
    getTotalPriceDisplay: function getTotalPriceDisplay() {
      if (!this.multipleAttr || this.multipleAttr.length === 0) {
        return '0';
      }

      // 计算所有选中规格值的价格总和
      var totalPrice = this.multipleAttr.reduce(function (sum, item) {
        var price = parseFloat(item.price) || 0;
        return sum + price;
      }, 0);
      return totalPrice.toFixed(2);
    },
    // 更新多规格模式下的multipleAttr数据结构（只存储选中的规格值）
    updateMultipleAttrStructure: function updateMultipleAttrStructure() {
      if (this.attrType === 'multi') {
        if (this.editableRules.length > 0) {
          // 根据editableRules构建multipleAttr数组，只包含选中的规格值
          this.multipleAttr = this.editableRules.map(function (rule) {
            // 获取当前选中的规格值（根据valueCode）
            var selectedRuleValue = rule.attrValues && rule.attrValues[rule.valueCode] ? rule.attrValues[rule.valueCode] : null;
            if (selectedRuleValue) {
              return {
                attrName: rule.attrName || rule.ruleName,
                attrValue: selectedRuleValue.valueName,
                // 只存储选中的规格值
                price: selectedRuleValue.price || '0',
                otPrice: selectedRuleValue.otPrice || '0',
                costPrice: selectedRuleValue.costPrice !== undefined && selectedRuleValue.costPrice !== null ? selectedRuleValue.costPrice : '',
                status: selectedRuleValue.status !== undefined ? selectedRuleValue.status : 1,
                ruleId: rule.id,
                valueIndex: rule.valueCode || 0
              };
            } else {
              // 如果没有选中的规格值，返回空结构
              return {
                attrName: rule.attrName || rule.ruleName,
                attrValue: '',
                price: '0',
                otPrice: '0',
                costPrice: '',
                status: 1,
                ruleId: rule.id,
                valueIndex: 0
              };
            }
          }).filter(function (item) {
            return item;
          }); // 过滤掉空值

          // 输出调试信息
          console.log('多规格模式下multipleAttr结构已更新（仅选中值）:', this.multipleAttr);
          console.log('选中的规格值详情:', this.multipleAttr.map(function (attr) {
            return {
              规格名: attr.attrName,
              选中值: attr.attrValue,
              售价: attr.price,
              原价: attr.otPrice,
              状态: attr.status === 1 ? '开启' : '关闭',
              索引: attr.valueIndex
            };
          }));
        } else {
          // 当没有选择规格时，重置为空数组
          this.multipleAttr = [];
          console.log('多规格模式下无规格，multipleAttr结构已重置');
        }
      }
    },
    // 表单验证
    validate: function validate() {
      var _this1 = this;
      return new Promise(function (resolve) {
        if (_this1.attrType === 'single') {
          if (_this1.hideDateModeStockFields || !_this1.$refs.singleSpecRef) {
            resolve(true);
            return;
          }
          // 先进行基础表单验证
          _this1.$refs.singleSpecRef.validate(function (valid) {
            if (!valid) {
              resolve(false);
              return;
            }

            // 基础验证通过后，进行起购量和限购量的关系验证
            var minQuantity = parseFloat(_this1.singleSpecForm.minQuantity) || 0;
            var maxQuantity = parseFloat(_this1.singleSpecForm.maxQuantity) || 0;
            if (minQuantity < 1) {
              _this1.$message.error('起购数量不能小于1，请检查后重新提交');
              resolve(false);
              return;
            }

            // 如果两个值都存在且起购量大于限购量
            if (minQuantity > 0 && maxQuantity > 0 && minQuantity > maxQuantity) {
              _this1.$message.error('起购数量不能大于限购数量，请检查后重新提交');
              resolve(false);
              return;
            }
            resolve(true);
          });
        } else {
          if (_this1.attrType === 'multi') {
            var invalidCostRows = [];
            _this1.editableRules.forEach(function (rule) {
              var ruleName = rule.attrName || rule.ruleName || '未命名规格';
              var attrValues = Array.isArray(rule.attrValues) ? rule.attrValues : [];
              attrValues.forEach(function (item, index) {
                var costPrice = item && item.costPrice;
                if (costPrice === '' || costPrice === null || costPrice === undefined || Number.isNaN(Number(costPrice))) {
                  var valueName = item && item.valueName ? item.valueName : "\u7B2C".concat(index + 1, "\u4E2A\u89C4\u683C\u503C");
                  invalidCostRows.push("".concat(ruleName, "-").concat(valueName));
                }
              });
            });
            if (invalidCostRows.length > 0) {
              _this1.$message.error("\u4EE5\u4E0B\u89C4\u683C\u503C\u7684\u6210\u672C\u4EF7\u4E0D\u80FD\u4E3A\u7A7A\uFF1A".concat(invalidCostRows.join('、')));
              resolve(false);
              return;
            }
          }

          // SKU库存模式：验证起购量必填及与限购量的关系
          // 多规格（无库存）没有起购量/限购字段，不参与该校验
          var invalidMinRows = [];
          var invalidRangeRows = [];
          if (_this1.attrType === 'sku') {
            _this1.skuCombinations.forEach(function (item, index) {
              var minQuantity = parseFloat(item.minQuantity);
              var maxQuantity = parseFloat(item.maxQuantity) || 0;
              var rowLabel = item.skuName || "\u7B2C".concat(index + 1, "\u4E2ASKU");
              if (item.minQuantity === '' || item.minQuantity === null || item.minQuantity === undefined || Number.isNaN(minQuantity) || minQuantity < 1) {
                invalidMinRows.push(rowLabel);
                return;
              }
              if (maxQuantity > 0 && minQuantity > maxQuantity) {
                invalidRangeRows.push(rowLabel);
              }
            });
          }
          if (invalidMinRows.length > 0) {
            _this1.$message.error("\u4EE5\u4E0B\u89C4\u683C\u7684\u8D77\u8D2D\u6570\u91CF\u4E3A\u5FC5\u586B\u9879\u4E14\u4E0D\u80FD\u5C0F\u4E8E1\uFF1A".concat(invalidMinRows.join('、')));
            resolve(false);
            return;
          }
          if (invalidRangeRows.length > 0) {
            _this1.$message.error("\u4EE5\u4E0B\u89C4\u683C\u7684\u8D77\u8D2D\u6570\u91CF\u4E0D\u80FD\u5927\u4E8E\u9650\u8D2D\u6570\u91CF\uFF1A".concat(invalidRangeRows.join('、'), "\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u65B0\u63D0\u4EA4"));
            resolve(false);
            return;
          }
          resolve(true);
        }
      });
    },
    // 生成SKU组合
    generateSkuCombinations: function generateSkuCombinations() {
      if (this.selectedRules.length === 0) {
        this.skuCombinations = [];
        this.selectedSkuIndex = 0;
        return;
      }

      // 收集所有规格值
      var specOptions = this.selectedRules.map(function (rule) {
        var ruleName = rule.attrName || rule.ruleName;
        return {
          ruleId: rule.id,
          ruleName: ruleName,
          values: rule.attrValues.map(function (item, index) {
            return {
              index: index,
              value: item.valueName || item.value || '',
              valueName: item.valueName || item.value || '',
              price: item.price || '0',
              otPrice: item.otPrice || '0',
              disabled: item.disabled === undefined ? 1 : item.disabled,
              // 添加规格名称，用于后续生成attrValue对象
              specName: ruleName,
              attrName: ruleName,
              ruleName: ruleName
            };
          })
        };
      });

      // 使用笛卡尔积算法生成所有可能的组合
      var combinations = this.cartesianProduct(specOptions.map(function (spec) {
        return spec.values;
      }));

      // 格式化组合数据
      // 重置选中索引
      this.selectedSkuIndex = 0;
      this.skuCombinations = combinations.map(function (combination, index) {
        // 生成规格名称
        var specName = combination.map(function (item) {
          return item.value || item.valueName || '';
        }).join(' ');

        // 生成attrValue对象格式：{"颜色": "蓝色", "尺码": "L", "口味": "骚味"}
        var attrValue = {};
        combination.forEach(function (item) {
          // 从item中获取规格名称和规格值
          var specName = item.specName || item.attrName || item.ruleName || '';
          var specValue = item.value || item.valueName || '';
          if (specName && specValue) {
            attrValue[specName] = specValue;
          }
        });

        // 生成SKU编码
        // const skuCode = `SKU${String(index + 1).padStart(4, '0')}`;
        var randomStr = Math.floor(1000 + Math.random() * 9000); // 生成4位随机数
        var skuCode = "SKU".concat(Date.now() + index + randomStr);

        // 计算默认价格和原价
        var price = combination.reduce(function (sum, item) {
          return sum + (parseFloat(item.price) || 0);
        }, 0).toFixed(2);
        var otPrice = combination.reduce(function (sum, item) {
          return sum + (parseFloat(item.otPrice) || 0);
        }, 0).toFixed(2);
        return {
          id: index + 1,
          skuCode: skuCode,
          skuName: specName,
          // 改名：specName -> skuName
          attrValue: JSON.stringify(attrValue),
          //{"颜色": "蓝色", "尺码": "L","口味":"骚味"}
          price: price,
          otPrice: otPrice,
          costPrice: '0',
          stock: '0',
          stockWarning: '0',
          minQuantity: '1',
          maxQuantity: 999,
          weight: '0',
          // 重量(kg)
          barCode: '',
          // 商品条码
          status: 1,
          // 改名：disabled -> status，默认上架
          image: '',
          // 改名：imageUrl -> image，图片URL
          checked: index === 0 // 改名：isSelected -> checked，默认选中第一个
        };
      });
    },
    // 笛卡尔积算法
    cartesianProduct: function cartesianProduct(arrays) {
      return arrays.reduce(function (acc, curr) {
        var res = [];
        acc.forEach(function (x) {
          curr.forEach(function (y) {
            res.push(Array.isArray(x) ? [].concat(_toConsumableArray(x), [y]) : [x, y]);
          });
        });
        return res;
      }, [[]]);
    },
    // 自定义上传SKU图片方法
    uploadSkuImage: function uploadSkuImage(row) {
      var _this = this;
      (0, _internal.uploadLocalImage)({
        multiple: false,
        maxCount: 1,
        model: 'product',
        pid: 1,
        validateAspectRatio: false,
        // SKU图片不强制要求1:1比例
        maxSizeInMB: 2,
        // 限制图片大小为2MB
        onSuccess: function onSuccess(url) {
          // 上传成功，设置SKU图片URL
          row.image = url;
        },
        onComplete: function onComplete(successUrls) {
          if (successUrls && successUrls.length > 0) {
            _this.$message.success('SKU图片上传成功');
          } else {
            _this.$message.warning('SKU图片上传失败');
          }
        },
        onError: function onError(error) {
          _this.$message.error(error.message || 'SKU图片上传失败');
        }
      });
    },
    // 处理SKU选中事件
    handleSkuSelect: function handleSkuSelect(row, index) {
      // 更新所有SKU的选中状态
      this.skuCombinations.forEach(function (item, idx) {
        item.checked = idx === index;
      });
      console.log('选中的SKU:', row);
      this.$emit('sku-selected', row);
    },
    // 自定义上传批量设置图片方法
    uploadBulkImage: function uploadBulkImage(row) {
      var _this = this;
      (0, _internal.uploadLocalImage)({
        multiple: false,
        maxCount: 1,
        model: 'product',
        pid: 1,
        validateAspectRatio: false,
        // 批量设置图片不强制要求1:1比例
        maxSizeInMB: 2,
        // 限制图片大小为2MB
        onSuccess: function onSuccess(url) {
          // 上传成功，设置批量设置图片URL
          row.image = url;
        },
        onComplete: function onComplete(successUrls) {
          if (successUrls && successUrls.length > 0) {
            _this.$message.success('批量设置图片上传成功');

            // 提示用户可以批量应用图片
            _this.$confirm('是否将此图片应用到所有SKU组合？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'info'
            }).then(function () {
              // 将图片应用到所有SKU组合
              if (_this.skuCombinations && _this.skuCombinations.length > 0) {
                _this.skuCombinations.forEach(function (sku) {
                  sku.image = row.image;
                });
                _this.$message.success('图片已批量应用到所有SKU组合');
              }
            }).catch(function () {
              // 用户取消操作
            });
          } else {
            _this.$message.warning('批量设置图片上传失败');
          }
        },
        onError: function onError(error) {
          _this.$message.error(error.message || '批量设置图片上传失败');
        }
      });
    },
    // 批量应用数据
    applyBulkData: function applyBulkData() {
      var _this10 = this;
      if (this.skuCombinations.length === 0) {
        this.generateSkuCombinations();
      }

      // 确认是否应用批量数据
      this.$confirm('确定要将批量设置的数据应用到所有规格组合吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 获取批量设置的数据
        var bulkData = _this10.bulkDataForm;

        // 应用到所有SKU组合
        _this10.skuCombinations.forEach(function (sku) {
          // 只更新有值的字段
          if (bulkData.otPrice !== '') {
            sku.otPrice = bulkData.otPrice;
          }
          if (bulkData.price !== '') {
            sku.price = bulkData.price;
          }
          if (bulkData.costPrice !== '') {
            sku.costPrice = bulkData.costPrice;
          }
          if (bulkData.stock !== '') {
            sku.stock = bulkData.stock;
          }
          if (bulkData.stockWarning !== '') {
            sku.stockWarning = bulkData.stockWarning;
          }
          if (bulkData.minQuantity !== '') {
            sku.minQuantity = bulkData.minQuantity;
          }
          if (bulkData.maxQuantity !== '') {
            sku.maxQuantity = bulkData.maxQuantity;
          }
          if (bulkData.weight !== '') {
            sku.weight = bulkData.weight;
          }
          if (bulkData.volumeLong !== '') {
            sku.volumeLong = bulkData.volumeLong;
          }
          if (bulkData.volumeWide !== '') {
            sku.volumeWide = bulkData.volumeWide;
          }
          if (bulkData.volumeHigh !== '') {
            sku.volumeHigh = bulkData.volumeHigh;
          }

          // 如果有商品条码，也应用商品条码
          if (_this10.showBarCodeField && bulkData.barCode !== '') {
            sku.barCode = bulkData.barCode;
          }

          // 如果有规格名称，也应用规格名称
          if (bulkData.specName !== '' && bulkData.specName !== '批量设置') {
            sku.skuName = bulkData.specName;
          }

          // 如果有图片，也应用图片
          if (bulkData.image) {
            sku.image = bulkData.image;
          }

          // 更新状态
          sku.status = bulkData.status;
        });
        _this10.$message.success('批量设置数据已应用到所有规格组合');
      }).catch(function () {
        // 用户取消操作
      });
    },
    // 删除SKU组合
    deleteSkuCombination: function deleteSkuCombination(index) {
      var _this11 = this;
      if (this.isEditMode) {
        this.$message.warning('编辑模式下不能删除已有SKU组合，可通过下架状态停售');
        return;
      }
      this.$confirm('确定要删除该SKU组合吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this11.skuCombinations.splice(index, 1);
        _this11.$message.success('删除成功');
      }).catch(function () {});
    },
    // 获取表单数据
    getFormData: function getFormData() {
      var _this12 = this;
      // 多规格售价、原价遵循“如置空为0元”，只规范提交数据，不改动输入框原值。
      var normalizeEmptyPrice = function normalizeEmptyPrice(price) {
        return price === '' || price === null || price === undefined ? 0 : price;
      };
      var multipleAttrGroups = this.attrType === 'multi' ? this.editableRules.map(function (rule) {
        return _objectSpread(_objectSpread({}, rule), {}, {
          attrValues: rule.attrValues.map(function (value) {
            return _objectSpread(_objectSpread({}, value), {}, {
              price: normalizeEmptyPrice(value.price),
              otPrice: normalizeEmptyPrice(value.otPrice)
            });
          })
        });
      }) : this.editableRules;

      // 整理规格数据，确保结构准确
      var formattedRules = this.editableRules.map(function (rule) {
        // 确保规格值数据结构正确
        var formattedValues = rule.attrValues.map(function (value) {
          return {
            value: value.valueName,
            price: value.price || '',
            otPrice: value.otPrice || '',
            status: value.status === undefined ? 1 : value.status
          };
        });
        return {
          id: rule.id,
          ruleName: rule.attrName || rule.ruleName,
          attrValues: formattedValues,
          valueCode: rule.valueCode || 0,
          parentRuleName: rule.parentRuleName // 保留父级规格名称
        };
      });

      // 获取所有规格的默认选中值
      var selectedSpecs = formattedRules.map(function (rule) {
        var defaultValue = rule.attrValues[rule.valueCode];
        return {
          ruleId: rule.id,
          ruleName: rule.ruleName,
          parentRuleName: rule.parentRuleName,
          valueIndex: rule.valueCode,
          value: defaultValue ? defaultValue.valueName : '',
          price: defaultValue ? defaultValue.price : '',
          otPrice: defaultValue ? defaultValue.otPrice : '',
          status: defaultValue ? defaultValue.status : 1
        };
      });

      // 计算默认组合的总价
      var defaultTotalPrice = selectedSpecs.reduce(function (total, spec) {
        var price = parseFloat(spec.price) || 0;
        return total + price;
      }, 0);

      // 按父级规格分组
      var groupedSpecs = {};
      selectedSpecs.forEach(function (spec) {
        var parentName = spec.parentRuleName || 'default';
        if (!groupedSpecs[parentName]) {
          groupedSpecs[parentName] = [];
        }
        groupedSpecs[parentName].push(spec);
      });

      // SKU模式下，添加SKU组合数据
      var skuData = null;
      if (this.attrType === 'sku' && this.skuCombinations.length > 0) {
        skuData = this.skuCombinations.map(function (sku) {
          return {
            skuCode: sku.skuCode,
            specName: sku.skuName,
            price: sku.price,
            otPrice: sku.otPrice,
            costPrice: sku.costPrice,
            stock: sku.stock,
            stockWarning: sku.stockWarning,
            minSellQuantity: sku.minQuantity,
            maxBuyQuantity: sku.maxQuantity,
            weight: sku.weight,
            barCode: _this12.showBarCodeField ? sku.barCode : '',
            disabled: sku.status
          };
        });
      }
      return {
        // 将字符串类型转换为对应的数字类型
        attrType: this.attrType === 'single' ? 1 : this.attrType === 'multi' ? 2 : 3,
        singleAttr: this.singleSpecForm,
        // selectedRules: formattedRules, // 使用可编辑的规则数据
        // selectedSpecs: selectedSpecs,
        // groupedSpecs: groupedSpecs, // 按父级规格分组的数据
        // defaultPrice: defaultTotalPrice.toFixed(2),
        // originalRules: this.originalRules, // 返回原始规则数据，以便后续比较
        // skuData: skuData, // SKU组合数据
        attr: this.attr,
        // SKU模式下的attr数据结构
        attrValue: this.skuCombinations,
        // sku库存数据
        multipleAttr: {
          "attrGroupName": "",
          "attrGroups": multipleAttrGroups
        } // 多规格(无库存数据)
      };
    },
    // 处理数字输入
    handleNumberInput: function handleNumberInput(value) {
      // 限制长度为6位
      if (value.length > 6) {
        return value.slice(0, 6);
      }
      // 移除负号和前导零
      return value.replace(/^0+(?=\d)/, '').replace(/-/g, '');
    },
    // 验证SKU选择输入框的起购量和限购量关系
    validateSkuQuantityRange: function validateSkuQuantityRange(row, index) {
      var minQuantity = parseFloat(row.minQuantity);
      var maxQuantity = parseFloat(row.maxQuantity) || 0;
      if (row.minQuantity === '' || row.minQuantity === null || row.minQuantity === undefined || Number.isNaN(minQuantity) || minQuantity < 1) {
        this.$message.error('起购数量为必填项且不能小于1');
        this.$set(row, 'minQuantity', '1');
        return false;
      }

      // 如果两个值都存在且起购量大于限购量
      if (minQuantity > 0 && maxQuantity > 0 && minQuantity > maxQuantity) {
        var skuName = row.skuName || "\u7B2C".concat(index + 1, "\u4E2ASKU");
        this.$message.error("".concat(skuName, "\u7684\u8D77\u8D2D\u6570\u91CF\u4E0D\u80FD\u5927\u4E8E\u9650\u8D2D\u6570\u91CF\uFF0C\u8BF7\u91CD\u65B0\u8BBE\u7F6E"));

        // 自动调整起购量为限购量的值
        this.$set(row, 'minQuantity', maxQuantity.toString());
        return false;
      }
      return true;
    }
  },
  watch: {
    includeWeightRuleName: function includeWeightRuleName(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        var oldRule = this.editableRules.find(function (r) {
          return r.attrName === oldVal;
        });
        console.log("oldRule>>>>>>>", oldRule);
        if (oldRule) {
          oldRule.attrValues.forEach(function (v) {
            v.weight = null;
            v.volumeLong = null;
            v.volumeWide = null;
            v.volumeHigh = null;
          });
        }
      }
    },
    isWmTg: {
      handler: function handler(newVal) {
        if (newVal === 2 || newVal === 3) {
          if (this.singleSpecForm) {
            this.singleSpecForm.barCode = '';
          }
          if (Array.isArray(this.skuCombinations)) {
            this.skuCombinations.forEach(function (sku) {
              sku.barCode = '';
            });
          }
          this.bulkDataForm.barCode = '';
        }
      },
      immediate: true
    },
    // 监听父组件传递的multipleAttr变化
    multipleAttr: {
      handler: function handler(newVal) {
        var _this13 = this;
        if (newVal && newVal.attrGroups && Array.isArray(newVal.attrGroups)) {
          //回显重量长宽高
          this.multipleAttr.attrGroups.forEach(function (s) {
            s.attrValues.forEach(function (x) {
              if (x.weight) {
                _this13.includeWeightRuleName = s.attrName;
              }
            });
          });
          // 深拷贝并规范化布尔值为数字
          this.editableRules = newVal.attrGroups.map(function (rule) {
            var normalizedRule = _objectSpread({}, rule);

            // 处理attrValues中的disabled和checked值
            if (normalizedRule.attrValues && Array.isArray(normalizedRule.attrValues)) {
              normalizedRule.attrValues = normalizedRule.attrValues.map(function (value, index) {
                var normalizedValue = _objectSpread({}, value);

                // 将disabled/status的布尔值转换为数字，优先使用status字段
                if (normalizedValue.status !== undefined) {
                  normalizedValue.status = normalizedValue.status === true ? 1 : normalizedValue.status === false ? 0 : normalizedValue.status;
                } else if (normalizedValue.disabled !== undefined) {
                  // 向后兼容：将disabled转换为status
                  normalizedValue.status = normalizedValue.disabled === true ? 1 : normalizedValue.disabled === false ? 0 : normalizedValue.disabled;
                  delete normalizedValue.disabled; // 删除旧的disabled字段
                } else {
                  normalizedValue.status = 1; // 默认开启
                }

                // 确保valueCode存在
                if (normalizedValue.valueCode === undefined) {
                  normalizedValue.valueCode = index;
                }
                normalizedValue.costPrice = normalizedValue.costPrice !== undefined && normalizedValue.costPrice !== null ? String(normalizedValue.costPrice) : '';
                return normalizedValue;
              });

              // 确保rule有valueCode，如果没有则设为第一个启用的规格值索引
              if (normalizedRule.valueCode === undefined || normalizedRule.valueCode === null) {
                // 查找第一个启用的规格值索引
                var firstEnabledIndex = normalizedRule.attrValues.findIndex(function (v) {
                  return v.status === 1;
                });
                normalizedRule.valueCode = firstEnabledIndex >= 0 ? firstEnabledIndex : 0;
              }
            }
            return normalizedRule;
          });

          // 同时更新selectedRules，确保与editableRules保持同步
          this.selectedRules = this.editableRules.map(function (rule) {
            return _objectSpread(_objectSpread({}, rule), {}, {
              id: rule.id,
              attrCode: rule.attrCode,
              // 确保attrCode也被复制
              attrValues: rule.attrValues.map(function (value) {
                return {
                  valueName: value.valueName,
                  price: value.price || '0',
                  otPrice: value.otPrice || '0',
                  costPrice: value.costPrice !== undefined && value.costPrice !== null ? String(value.costPrice) : '',
                  status: value.status,
                  valueCode: value.valueCode // 确保valueCode也被复制
                };
              })
            });
          });
          console.log('父组件multipleAttr变化，更新并规范化editableRules:', this.editableRules);
          console.log('同步更新selectedRules:', this.selectedRules);
        }
      },
      deep: true,
      immediate: true
    },
    // 监听父组件传递的attr变化（SKU模式）
    attr: {
      handler: function handler(newVal) {
        var _this14 = this;
        console.log('attr变化:', newVal);
        // 支持数组和对象两种格式
        var shouldProcess = this.attrType === 'sku' && newVal && !this._isUpdatingFromProps && (Array.isArray(newVal) && newVal.length > 0 || _typeof(newVal) === 'object' && !Array.isArray(newVal) && Object.keys(newVal).length > 0);
        if (shouldProcess) {
          this._isUpdatingFromProps = true;

          // 如果是对象，尝试提取数组
          var attrArray = newVal;
          if (!Array.isArray(newVal)) {
            // 可能的对象格式转换
            if (newVal.attr && Array.isArray(newVal.attr)) {
              attrArray = newVal.attr;
            } else if (Object.keys(newVal).length > 0) {
              // 转换对象为数组格式
              attrArray = Object.values(newVal);
            }
          }
          if (Array.isArray(attrArray) && attrArray.length > 0) {
            this.initializeSkuFromAttr(attrArray);
          }
          this.$nextTick(function () {
            _this14._isUpdatingFromProps = false;
          });
        }
      },
      deep: true,
      immediate: true
    },
    // 监听父组件传递的attrValue数据
    attrValue: {
      handler: function handler(newVal) {
        console.log('=== attrValue属性监听器触发 ===');
        console.log('新的attrValue数据:', newVal);
        console.log('数据类型:', Array.isArray(newVal) ? 'Array' : _typeof(newVal));
        console.log('数据长度:', newVal === null || newVal === void 0 ? void 0 : newVal.length);

        // 如果有attrValue数据且在SKU模式下，初始化SKU组合
        if (Array.isArray(newVal) && newVal.length > 0 && this.attrType === 'sku') {
          console.log('开始从父组件传递的attrValue初始化SKU数据');
          this.initializeSkuCombinationsFromAttrValue(newVal);
        }
      },
      deep: true,
      immediate: true
    },
    selectedRules: {
      handler: function handler(newVal) {
        if (this._isInitializing) {
          console.log('正在初始化，跳过selectedRules变化处理');
          return;
        }

        // 当规格变化时，更新SKU组合
        this.updateSkuCombinations();

        // SKU模式下，同时更新attr结构
        if (this.attrType === 'sku') {
          this.updateAttrStructure();
        }
      },
      deep: true
    },
    editableRules: {
      handler: function handler(newVal) {
        if (this._isInitializing) {
          console.log('正在初始化，跳过editableRules变化处理');
          return;
        }

        // 当规格值变化时，更新SKU组合
        this.updateSkuCombinations();

        // SKU模式下，同时更新attr结构
        if (this.attrType === 'sku') {
          this.updateAttrStructure();
        }

        // 多规格模式下，同时更新multipleAttr结构
        if (this.attrType === 'multi') {
          this.updateMultipleAttrStructure();
        }
      },
      deep: true
    },
    // 专门监听规格类型切换，处理不同模式下的attr
    attrType: {
      handler: function handler(newVal, oldVal) {
        // 保存初始类型，用于编辑模式下恢复
        if (!this.originalAttrType) {
          this.originalAttrType = newVal;
        }
        if (newVal === 'sku') {
          // 切换到SKU模式时，初始化attr结构
          this.updateAttrStructure();
          // 清空多规格模式的数据
          this.multipleAttr = [];
        } else if (newVal === 'multi') {
          // 切换到多规格模式时，初始化multipleAttr结构
          this.updateMultipleAttrStructure();
          // 重置SKU模式的attr结构
          this.attr = [{
            "attrName": "",
            "attrValues": "",
            "id": 0
          }];
        } else {
          // 切换到单规格模式时，清空所有attr结构
          if (oldVal === 'sku') {
            this.attr = [{
              "attrName": "",
              "attrValues": "",
              "id": 0
            }];
            console.log('已切换出SKU模式，attr结构已重置');
          }
          if (oldVal === 'multi') {
            this.multipleAttr = [];
            console.log('已切换出多规格模式，multipleAttr结构已重置');
          }
        }
      },
      immediate: true // 立即执行一次，确保初始化时保存原始类型
    },
    skuCombinations: {
      handler: function handler(newVal) {
        console.log('SKU组合数据已更新:', newVal);
      },
      deep: true
    }
  }
};